define('SC.HorizonThemeExtension.Header', [
  'underscore',
  'SC.HorizonThemeExtension.Common.Configuration',
  'SC.HorizonThemeExtension.Common.LayoutHelper'
], function ThemeExtensionHeader(_, Configuration, LayoutHelper) {
  'use strict';

  return {
    loadModule: function loadModule() {
      LayoutHelper.addToViewContextDefinition(
        'Header.View',
        'extraHeaderView',
        'object',
        function () {
          return {
            bannertext: Configuration.get('header.bannerText')
          };
        }
      );
    }
  };
});
